import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { LogOut, CreditCard, Plus, HelpCircle } from 'lucide-react';
import CreditPurchaseModal from '../payment/CreditPurchaseModal';
import QuickStartGuideModal from '../guide/QuickStartGuideModal';

export default function Navbar({ breadcrumb }) {
  const { currentUser, userData, logout } = useAuth();
  const navigate = useNavigate();
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [showGuide, setShowGuide] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const handlePaymentSuccess = (paymentDetails) => {
    console.log('Payment successful:', paymentDetails);
    // Could show a toast notification here
  };

  return (
    <>
      <nav className="bg-white dark:bg-dark-bg border-b border-gray-200 dark:border-dark-border sticky top-0 z-40">
        <div className="mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Breadcrumb area */}
            <div className="flex-1">
              {breadcrumb}
            </div>

            {/* Right side */}
            <div className="flex items-center gap-4">
              {/* Quick Start Guide */}
              <button
                onClick={() => setShowGuide(true)}
                className="text-gray-600 dark:text-gray-400 hover:text-emerald-600 dark:hover:text-emerald-400 hover:bg-emerald-50 dark:hover:bg-emerald-900/20 rounded-lg p-2 transition"
                title="Quick Start Guide"
              >
                <HelpCircle className="w-5 h-5" />
              </button>

              {/* Credit Balance with Buy Button */}
              <div className="flex items-center">
                <div className="flex items-center gap-2 px-3 py-1.5 bg-emerald-50 dark:bg-emerald-900/20 border border-emerald-200 dark:border-emerald-700 rounded-l-lg">
                  <CreditCard className="w-4 h-4 text-emerald-600 dark:text-emerald-400" />
                  <span className="text-sm font-semibold text-emerald-900 dark:text-emerald-100">
                    {userData?.credits || 0}
                  </span>
                </div>
                <button
                  onClick={() => setShowPurchaseModal(true)}
                  className="flex items-center gap-1 px-2 py-1.5 bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-medium rounded-r-lg transition"
                  title="Buy Credits"
                >
                  <Plus className="w-4 h-4" />
                  <span className="hidden sm:inline">Buy</span>
                </button>
              </div>

              {/* Logout Button */}
              <button
                onClick={handleLogout}
                className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-gray-700 dark:text-gray-300 hover:text-red-600 dark:hover:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition"
              >
                <LogOut className="w-4 h-4" />
                <span className="hidden sm:inline">Logout</span>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Credit Purchase Modal */}
      <CreditPurchaseModal
        isOpen={showPurchaseModal}
        onClose={() => setShowPurchaseModal(false)}
        onPaymentSuccess={handlePaymentSuccess}
      />

      {/* Quick Start Guide Modal */}
      <QuickStartGuideModal
        isOpen={showGuide}
        onClose={() => setShowGuide(false)}
      />
    </>
  );
}
